import GlobalSearchResults from "./GlobalSearchResults";

export default GlobalSearchResults;
